import { render, staticRenderFns } from "./AngleSelect.vue?vue&type=template&id=959c487a&"
import script from "./AngleSelect.vue?vue&type=script&lang=js&"
export * from "./AngleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/utils/angleSelect/AngleSelect.vue"
export default component.exports